'use strict';

var functionIndex = require('./functions');

module.exports = function getFunctions() {
  var currentFunctionCodes = this.getFunctionCodes();
  var currentFunctions = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = currentFunctionCodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var fragment = _step.value;

      if (functionIndex[fragment.idCode]) {
        var currentFunction = JSON.parse(JSON.stringify(functionIndex[fragment.idCode]));
        currentFunction.atomMap = fragment.atomMap;
        currentFunctions.push(currentFunction);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return currentFunctions;
};


// WEBPACK FOOTER //
// ./lib/extend/functions/getFunctions.js